import React from 'react'

export const AwardsScreen = (): React.ReactElement => {
  return <></>
}
